import { render, staticRenderFns } from "./FormatSelector.vue?vue&type=template&id=6e9e7d7a&scoped=true&"
import script from "./FormatSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9e7d7a",
  null
  
)

export default component.exports